import { Components } from 'formiojs'

const Select = Components.components.select

export class DirectoryEntrySelectComponent extends Select {
  static schema(...extend) {
    return Select.schema({
      type: 'directoryEntrySelect',
      label: 'Directory Entry Select',
      key: 'directoryEntrySelect'
    })
  }

  static get builderInfo() {
    return {
      title: 'Verzeichniseintrag Auswahl',
      icon: 'th-list',
      documentation: '/userguide/#select',
      weight: 0,
      schema: DirectorySelectComponent.schema()
    }
  }

  constructor(component, options, data) {
    super(component, options, data)
  }

  init() {
    super.init()
  }

  render(content) {
    const container = document.createElement('div')
    const flexContainer = document.createElement('div')
    const refreshButton = document.createElement('button')
    const createNewEntryLink = document.createElement('a')

    flexContainer.style.display = 'flex'
    flexContainer.style.gap = '0.25rem'

    refreshButton.setAttribute('ref', this.id + '-refresh')
    refreshButton.type = 'button'
    refreshButton.className = 'btn btn-secondary'
    refreshButton.innerHTML = '<i class="fa fa-refresh"></i>'

    createNewEntryLink.href = `/directories/${this.component.verzeichnis}?add=true`
    createNewEntryLink.target = '_blank'
    createNewEntryLink.className = 'icon-link p-2 flex items-center gap-1'
    createNewEntryLink.innerHTML = '<i class="fa fa-plus"></i>Neuen Eintrag erstellen'

    container.innerHTML = super.render(content)

    const select = container.querySelector(`#${this.id}-${this.component.key}`)
    const input = container.querySelector('input')

    if (select) {
      select.parentElement.removeChild(select)
      flexContainer.appendChild(select)
      flexContainer.appendChild(refreshButton)

      input.after(createNewEntryLink)
      input.after(flexContainer)
    }

    return container.innerHTML
  }

  setItems(items: any[], fromSearch) {
    if (items && items.length > 0) {
      items.sort((a, b) => {
        const labelA = String((this as any).itemTemplate(a))
          .replace(/(<([^>]+)>)/gi, '')
          .trim()
        const labelB = String((this as any).itemTemplate(b))
          .replace(/(<([^>]+)>)/gi, '')
          .trim()

        return labelA.localeCompare(labelB)
      })
    }

    const options = (this.selectOptions as unknown as any[]) || []

    if (items?.length !== this.selectOptions?.length) {
      const missingItem = options.find((item) => !items.find((i) => i.id === item.value.id))?.value

      if (missingItem) {
        items.unshift(missingItem)
      }
    }

    // @ts-expect-error making sure setItems exists
    if (!super.setItems) {
      return
    }

    // @ts-expect-error we know this is a Select component
    return super.setItems(items, fromSearch)
  }

  attach(element) {
    this.loadRefs(element, {
      [this.id + '-refresh']: 'single'
    })

    this.addEventListener(this.refs[this.id + '-refresh'], 'click', () => {
      super.updateItems()
    })

    return super.attach(element)
  }

  detach() {
    return super.detach()
  }

  destroy() {
    return super.destroy()
  }

  normalizeValue(value, flags = {}) {
    return super.normalizeValue(value)
  }

  getValue() {
    return super.getValue()
  }

  getValueAt(index) {
    return super.getValueAt(index)
  }

  setValue(value, flags = {}) {
    return super.setValue(value, flags)
  }

  setValueAt(index, value, flags = {}) {
    return super.setValueAt(index, value, flags)
  }
}
